import { useFormikContext } from 'formik'
import { useMemo } from 'react'
import { IFilterSet } from '../../typings'
import { normalizeFilters } from '../../utils'

export function useListData<U, T extends IFilterSet<U>>() {
  const { values } = useFormikContext<T>()

  const validKeys = useMemo(
    () => normalizeFilters<U, T>(values).validKeys,
    [values],
  )

  return {
    validKeys,
  }
}
